import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { FaqAll } from "../components/faq/FaqAll";
import { IBannerData, IFaqsData } from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";
import { fetchEnglishFaqs, fetchNepaliFaqs } from "../api/FaqApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { fetchFAQsBanner } from "../api/BannerApi";

const FaqPage = () => {
  const { setLoading } = useLoader();
  const [englishFaqs, setEnglishFaqs] = useState<IFaqsData[]>([]);
  const [nepaliFaqs, setNepaliFaqs] = useState<IFaqsData[]>([]);
  const [faqsBanner, setFaqsBanner] = useState<IBannerData[]>([]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  
  useEffect(() => {
    setLoading(true);
    Promise.all([fetchEnglishFaqs(), fetchNepaliFaqs(), fetchFAQsBanner()])
      .then(([englishFaqsData, nepaliFaqsData, faqsBannerData]) => {
        setEnglishFaqs(englishFaqsData);
        setNepaliFaqs(nepaliFaqsData);
        setFaqsBanner(faqsBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  return (
    <>
      <Banner title="Faq" bannerImage={faqsBanner?.[0]?.image?.[0]} />
      <FaqAll englishFaqs={englishFaqs} nepaliFaqs={nepaliFaqs} />
    </>
  );
};

export default FaqPage;
